export const UploadImageApi = Symbol('UploadImageApi');

export interface UploadImageApi {
  uploadImage(file: File, onProgress?: (percent: number) => void): Promise<Record<any, any>>;
}
